import styled, { css } from 'styled-components';
import { BlockInputField } from '@common/components/FormElements';
import getContrastFontColor from '@utils/getContrastFontColor';
import { media } from 'styled-bootstrap-grid';
import { IconButton } from '../IconButton';

export const StyledTextInput = styled(BlockInputField)`
  cursor: pointer;
  padding: 16px 0 16px 10px;
  caret-color: transparent;
  ${media.md`
    padding: 11px 10px;
  `}
`;

export const GuestPickerWrapper = styled.div<{ isInsideModal: boolean }>`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: calc(66% - 2px);
    right: 12px;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 4px 3px 0px;
    border-color: ${({ theme }) => theme.defaultColors.fontPrimary} transparent transparent;
    margin-left: 10px;
  }

  ${media.md`
    width: 190px;
  `}

  ${({ isInsideModal }) =>
    isInsideModal &&
    css`
      width: 100%;
    `}
`;

export const PlusIconButton = styled(IconButton)`
  background: ${({ theme }) => theme.customColors.primary};

  & > svg {
    color: ${({ theme }) =>
      `${getContrastFontColor(theme.defaultColors.fontPrimary, theme.customColors.primary)}`};
  }
`;

export const EditingGuestsContainer = styled.div`
  position: absolute;
  top: -20px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999999;
  height: fit-content;
  display: block;

  div[class*='MenuList'] {
    max-height: 200px !important;
  }
`;

export const RoomLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const RoomLabel = styled.span`
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
`;

export const RemoveText = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.customColors.secondary};
`;

export const AddAnotherRoomButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 12px;
`;
